import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { SrxApi } from '../../api/SrxApi';

const useDeleteOrderReturn = () => {
    const { mutate: deleteOrderReturn, isLoading } = useMutation(
        async (itemIds) => {
            await Promise.all(itemIds.map((id) => SrxApi.delete(`/orderReturns/${id}`)));
        },
        {
            onSuccess: () => {
                toast.success('Order return deleted successfully!');
            },
            onError: (error) => {
                const errorMessage =
                    error?.response?.data?.message || error?.message || 'Failed to delete order return';
                toast.error(errorMessage);
            },
        }
    );

    return {
        deleteOrderReturn,
        isDeleteOrderReturnLoading: isLoading,
    };
};

export default useDeleteOrderReturn;
